import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddHospitalNotifyToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/hospitalNotify/store/hospitalNotify.actions'
import { addHospitalNotifyItem } from '../../timeline/store/timeline.actions'
import { HospitalNotifyConstants } from '../../procedures/hospitalNotify/store/hospitalNotify.constants'

export function* saveHospitalNotifyQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addHospitalNotifyToTimeline } = quickActionsObject
  if (addHospitalNotifyToTimeline) {
    yield put(addHospitalNotifyItem())
    yield put(setAddHospitalNotifyToTimeline(false))
    yield put(resetState())
  }
}

export function* saveHospitalNotifyQuickActionTimeLineRowSaga() {
  yield takeLatest([HospitalNotifyConstants.SET_ADD_TO_TIMELINE], saveHospitalNotifyQuickActionTimeLineRow)
}
